import * as R from 'ramda'
import P from 'helpers/predicates'
import {
  RESET_SELECTED_ROLE,
  RESET_SELECTED_USER,
  UPDATE_SELECTED_USER,
  UPDATE_SELECTED_ROLE,
} from './constants'
import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'
import {
  ROLE_OPTIONS
} from 'containers/Admin/User/UserSelection/constants'

const resetSelectedUser = () => ''
const resetSelectedRole = () => ROLE_OPTIONS['Limited Access']
const updateSelectedUser = (prev, { username }) => P.isNotNil(username)
  ? username
  : prev

const updateSelectedRole = (prev, { role }) => P.isNotNil(role)
  ? role
  : prev

const selectedUserReducer = createReducer('', {
  [RESET_SELECTED_USER]: resetSelectedUser,
  [UPDATE_SELECTED_USER]: updateSelectedUser
})

const selectedRoleReducer = createReducer(ROLE_OPTIONS['Limited Access'], {
  [RESET_SELECTED_ROLE]: resetSelectedRole,
  [UPDATE_SELECTED_ROLE]: updateSelectedRole
})

export default combineReducers({
  user: selectedUserReducer,
  role: selectedRoleReducer,
})
